export default "__VITE_PUBLIC_ASSET__c51c5502__"